"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizes = exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _classnames = _interopRequireDefault(require("classnames"));
require("./index.css");
var _excluded = ["field", "size", "className"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var sizes = exports.sizes = {
  xs: 'custom-switch-xs',
  sm: 'custom-switch-sm',
  md: '',
  lg: 'custom-switch-lg'
};
var Switch = function Switch(_ref) {
  var _ref$field = _ref.field,
    field = _ref$field === void 0 ? false : _ref$field,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    className = _ref.className,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var sizeClass = sizes[size];
  var Input = (0, _react.useCallback)(function (inputProps) {
    return field ? /*#__PURE__*/_react["default"].createElement(_formik.Field, {
      name: inputProps.name,
      render: function render(fieldProps) {
        return /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, inputProps, fieldProps.field, {
          checked: fieldProps.field.value,
          onChange: function onChange(e) {
            fieldProps.field.onChange(e);
            inputProps.onChange && inputProps.onChange(e);
          }
        }));
      }
    }) : /*#__PURE__*/_react["default"].createElement("input", inputProps);
  }, [field, props]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('relative custom-switch', sizeClass, className)
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "flex"
  }, /*#__PURE__*/_react["default"].createElement(Input, (0, _extends2["default"])({
    className: (0, _classnames["default"])('custom-switch-input'),
    type: "checkbox"
  }, props)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "custom-switch-btn"
  })));
};
Switch.displayName = 'Switch';
var _default = exports["default"] = Switch;
//# sourceMappingURL=index.js.map